module.exports = __webpack_public_path__ + "img/phase_c.206b3f89.svg";